export function tryParseInt(raw: string | number | string[]): number | undefined {
    if (typeof raw === "number") {
        return raw;
    }

    if (typeof raw === "string") {
        const deviceId = parseInt(raw);
        if (!isNaN(deviceId)) {
            return deviceId;
        }
    }
}

export function tryParseString(raw: string | number): string | undefined {
    if (typeof raw == "string") {
        return raw;
    } else if (typeof raw === "number") {
        return raw.toString();
    }
}